module.exports = __webpack_public_path__ + "img/background-logo.089163c3.svg";